import { render, staticRenderFns } from "./OnSitePayments.vue?vue&type=template&id=523a7b0d&scoped=true"
import script from "./OnSitePayments.vue?vue&type=script&lang=js"
export * from "./OnSitePayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523a7b0d",
  null
  
)

export default component.exports